import React, { forwardRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { GridActionsCellItem } from "@mui/x-data-grid";
import * as Icons from "react-bootstrap-icons";
import Inputer from "Utils/Helpers/Inputer";
import { useSetState } from "Utils/Helpers/Hooks";
import { Grid2 } from "@mui/material";
import MButton from "Utils/Helpers/MButton";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setWhitepaperData } from "../../../../../Redux/slices/mngrSlice";
import MFieldImage from "Utils/Helpers/MFieldImage";
import { put_whitepaper } from "http/components/Whitepaper";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditWhitepapersData({ row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [image, setImage] = useState(null);
  const [controls, setControls] = useSetState({
    title_en: {
      label: "Title (en)",
      type: "text",
      multiLine: false,
      placeholder: "Title (en)",
      value: "",
      validation: false,
    },
    description_en: {
      label: "Description (en)",
      type: "text",
      multiLine: true,
      placeholder: "Description (en)",
      value: "",
      validation: false,
    },
    title_fr: {
      label: "Title (fr)",
      type: "text",
      multiLine: false,
      placeholder: "Title (fr)",
      value: "",
      validation: false,
    },
    description_fr: {
      label: "Description (fr)",
      type: "text",
      multiLine: true,
      placeholder: "Description (fr)",
      value: "",
      validation: false,
    },
    title_it: {
      label: "Title (it)",
      type: "text",
      multiLine: false,
      placeholder: "Title (it)",
      value: "",
      validation: false,
    },
    description_it: {
      label: "Description (it)",
      type: "text",
      multiLine: true,
      placeholder: "Description (it)",
      value: "",
      validation: false,
    },
  });

  const onEnter = () => {
    setControls({
      title_en: { value: row.languages.en.title, validation: true },
    });
    setControls({
      title_fr: { value: row.languages.fr.title, validation: true },
    });
    setControls({
      title_it: { value: row.languages.it.title, validation: true },
    });
    setControls({
      description_en: { value: row.languages.en.description, validation: true },
    });
    setControls({
      description_fr: { value: row.languages.fr.description, validation: true },
    });
    setControls({
      description_it: { value: row.languages.it.description, validation: true },
    });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const onSelectImage = (selected) => {
    setImage(selected);
  };

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onSubmit = async () => {
    const {
      title_en,
      description_en,
      title_fr,
      description_fr,
      title_it,
      description_it,
    } = controls;
    if (title_en.validation && description_en.validation) {
      dispatch(HandleLoading(true));
      let formData = new FormData();
      formData.append("id", row.id);
      formData.append(
        "title",
        JSON.stringify({
          en: title_en.value ? title_en.value : "",
          fr: title_fr.value ? title_fr.value : "",
          it: title_it.value ? title_it.value : "",
        })
      );
      formData.append(
        "description",
        JSON.stringify({
          en: description_en.value ? description_en.value : "",
          fr: description_fr.value ? description_fr.value : "",
          it: description_it.value ? description_it.value : "",
        })
      );
      formData.append("image", image || "1a67d29f5");
      const response = await put_whitepaper(formData);
      if (CheckApiStatus(response)) {
        dispatch(setWhitepaperData(true));
        enqueueSnackbar("Edit Success", { variant: "success" });
      }
      setShow(false);
      setImage(null);
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <>
      <GridActionsCellItem
        icon={<Icons.Pencil size={16} />}
        label="Edit"
        onClick={setShowDialog}
        className="btn-manager btn-edit"
      />
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"sm"}
          onClose={handleClose}
          TransitionProps={{ onEnter: onEnter }}
          aria-describedby="alert-dialog-edit"
        >
          <DialogTitle>{`Edit (${row.title})`}</DialogTitle>
          <DialogContent>
            {show && (
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12 }}>
                  <MFieldImage
                    name={"Icon (transparent png)"}
                    image={image}
                    lastImage={row.image}
                    onChange={onSelectImage}
                  />
                </Grid2>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid2
                      size={{ sm: key === "tags" ? 12 : 6, xs: 12 }}
                      key={key + index}
                    >
                      {controls[key].type === "text" && (
                        <Inputer
                          id={key}
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          label={controls[key].label}
                          placeholder={controls[key].placeholder}
                          type={controls[key].type}
                          multiLine={controls[key].multiLine}
                        />
                      )}
                    </Grid2>
                  );
                })}
              </Grid2>
            )}
          </DialogContent>
          <DialogActions>
            <MButton
              label={"Close"}
              color="secondary"
              onClick={handleClose}
              className="flex-grow-1"
            />
            <MButton
              label={"Update"}
              className="flex-grow-1"
              onClick={onSubmit}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
